import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Copy = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M15 9V4.25C15 3.55964 14.4404 3 13.75 3H4.25C3.55964 3 3 3.55964 3 4.25V13.75C3 14.4404 3.55964 15 4.25 15H9M10.25 9H19.75C20.4404 9 21 9.55964 21 10.25V19.75C21 20.4404 20.4404 21 19.75 21H10.25C9.55964 21 9 20.4404 9 19.75V10.25C9 9.55964 9.55964 9 10.25 9Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V16H4C2.89543 16 2 15.1046 2 14V4ZM14.5 8H10C8.89543 8 8 8.89543 8 10V14.5H4C3.72386 14.5 3.5 14.2761 3.5 14V4C3.5 3.72386 3.72386 3.5 4 3.5H14C14.2761 3.5 14.5 3.72386 14.5 4V8Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
